import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import { MagnetMotion } from '@sohanscript/ui/magnet-motion';
import { SrOnly } from '@sohanscript/ui/sr-only';
import { WithTooltip } from '@sohanscript/ui/tooltip';
import type { ComponentProps } from 'react';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';
import { Link } from '@/components/link';

type SocialsProps = ComponentProps<'div'> & {
	withLabel?: boolean;
	size?: 'sm' | 'lg' | 'default';
};

export function Socials({
	className,
	withLabel,
	size = 'default',
	...props
}: SocialsProps) {
	const socials = useSohanEmon().socials;
	return (
		<div
			className={cn('flex items-center gap-3 md:gap-4', className)}
			{...props}
		>
			{socials?.map((el) => (
				<Link
					to={el.url as `https://${string}`}
					target="_blank"
					rel="noopener noreferrer"
					aria-label={el.label}
					key={el.url}
					className="hover:text-foreground-light"
				>
					<SrOnly>{m.socials_open({ label: el.label })}</SrOnly>
					<WithTooltip
						className="flex items-center"
						content={el.label}
						offset={10}
					>
						<MagnetMotion>
							<Iconify
								className={cn(
									'size-6.5 hover:text-foreground-light',
									size === 'sm' && 'size-5',
								)}
								icon={el.icon ?? 'mdi:link'}
							/>
						</MagnetMotion>
						{withLabel && (
							<p className="relative ms-1">
								{el.label}
								<span className="absolute -bottom-0.5 left-0 h-px w-0 bg-foreground-light transition-[width] duration-300 group-hover:w-full" />
							</p>
						)}
					</WithTooltip>
				</Link>
			))}
		</div>
	);
}
